export default __webpack_public_path__ + "static/media/preview-video.556b23a5.jpg";